/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var SubmitFiling = require('../services/SubmitFiling');

var tmplCorpFinExtFilingCertificationSectionView = require('../templates/CorpFinExtCreateFilingCertificationSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinExtFilingCertificationSectionView,

  className: 'corp-fin-ext-filing-certification-section-view',

  ui: {
    certificationForm: '.certification-form',
    validationErrors: '.validation-errors',
    validationErrorSections: '.validation-error-sections',
    submit: '.submit'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.filingId;
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;

    var l = Ladda.create(this.ui.submit[0]);

    this.sideNavView
      .validateAll({ type: 'submit' })
      .done(function() {
        l.start();
        self.ui.validationErrors.hide();

        var formData = self.sideNavView.getFormData();
        formData.genericSubmissionForm.filingId = self.filingId;

        SubmitFiling(formData.genericSubmissionForm)
          .done(function(filingId) {
            self.filingId = filingId;
            Radio.channel('cf:filing').trigger('proceed-to-payment', filingId, l);
          })
          .fail(function() {
            l.stop();
          });
      })
      .fail(function() {
        var errors = self.sideNavView.getSectionTitlesWithErrors();
        self.ui.validationErrorSections.empty();
        self.ui.validationErrorSections.append(errors.join('<br/>'));
        self.ui.validationErrors.show();
        l.stop();
      });
  },

  validate: function(config) {
    this.ui.validationErrors.hide();
    this.ui.certificationForm.parsley().reset();
    return this.ui.certificationForm.parsley().whenValidate();
  },

  getFormData: function() {
    return Syphon.serialize(this);
  }
});
